module.exports = __webpack_public_path__ + "static/hob2-537df3d9bd60ebdba60f5576be2a92d0.jpg";